import React from "react";

import Profile from '../img/profile.png';
import ButtonNext from '../img/button_next.png';

class Community extends React.Component {
  render() {
    return (
      <div class="container d-flex h-100">
        <div class="align-self-center w-100 row text-center">
          <div class ="col-lg-6 col-md-6 offset-lg-3" style = {{textAlign: 'left'}}>
            <h1 class = 'jobs-moving-title jobs-heading-title community-modifier'>Our Community Activities</h1>
              <div class = 'community-background'>
                <p class = 'jobs-paragraph'>
                <div style = {{height:'5px', width: '30px', backgroundColor:'#e0df87'}} />
                <h4 class = 'community-title-modifier article-title'>Stay Tuned to Our Tech Community Activities</h4>
                <br/>
                <strong>Upcoming Event</strong><br/>
                <p>
                  A lot of things done here at <strong>Oval Tech</strong> are only possible because of the tireless efforts from the people in the technology community. For that, we feel like we have a responsibility to share back what we learned ourselves to the community. We would update you on any community event plans through this section of the site.
                </p>
                <hr/>
                <div class = 'row' style = {{margin:'10px'}}>
                  <div class = 'col-3'>
                    <img class = 'circled-image circled-image-community' src = {Profile} width = '30px' />
                  </div>
                  <div class = 'col-9'>
                    <p style = {{lineHeight: 1.3, marginBottom:0}}>
                      <span class = 'community-contributor'><strong>By any of us</strong></span><br/>
                      <span class = 'community-contributor-title'>Proud Technologists and Engineers at Oval Tech</span>
                    </p>
                  </div>
                </div>
              </p>
            </div>
          </div>
          <div class ="col-lg-3 col-md-6">
            <div class = 'community-background community-second-modifier'>
              <ul class = 'community-table-list'>
                <li>Discussing new trends and new ways to work</li>
                <li>Sharing new insights in using any particular technology</li>
                <li>Opening up parts of our codebases to use as an open source reseource</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Community;



// WEBPACK FOOTER //
// ./src/components/Community.js